import { CampaignsContent } from '~/features/campaigns/CampaignsContent'

export default CampaignsContent
